<template>
  <div
    id="sac-search"
    :style="{
      width: width ? `${width}px` : '100%',
      height: height ? `${height}px` : '48px',
    }"
  >
    <input
      v-model="searchValue"
      :class="[
        'sac-input',
        darkMode ? 'darkMode' : '',
      ]"
      :placeholder="placeholder"
    >
    <button
      class="sac-search-button"
      @click.stop="searchInput"
    >
      <img
        :class="['search-icon', darkMode ? 'white-icon' : '']"
        src="@shared/assets/img/table/search.png"
        alt="search"
      >
    </button>
    <button
      v-if="searchValue.length > 0"
      class="sac-clear-button"
      @click.stop="clearInput"
    >
      <img
        :class="['clear-icon', darkMode ? 'white-icon' : '']"
        src="@shared/assets/img/table/x.png"
        alt="clear"
      >
    </button>
  </div>
</template>

<script>
export default {
  name: 'SACSearch',
  props: {
    search: {
      type: String,
      required: true,
    },
    width: {
      type: Number,
      required: false,
    },
    height: {
      type: Number,
      required: false,
    },
    darkMode: Boolean,
    placeholder: {
      type: String,
      default: 'Search',
    },
  },
  data() {
    return {
      searchValue: this.search,
    };
  },
  watch: {
    searchValue() {
      this.$emit('input', this.searchValue);
    },
  },
  methods: {
    searchInput() {
      if (this.search.length > 0) {
        this.$emit('input', '');
        this.searchValue = '';
      }
    },
    clearInput() {
      this.$emit('input', '');
      this.searchValue = '';
    },
  },
};
</script>

<style lang="scss">

#sac-search {
  display: flex;
  align-items: center;
  position: relative;

  .sac-input {
    height: 100%;
    background-color: $N5;
    border-radius: 8px;
    width: 100%;
    padding: 0 50px;

    &::placeholder {
      font-size: 15px;
      color: $NAVY100;
    }

    &.darkMode {
      color: $WHITE;
      background-color: $N95;

      &:hover {
        background-color: $N90;
      }

      &:focus {
        background-color: $N90;
      }

      &::placeholder {
        color: $WHITE;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .sac-clear-button {
    position: absolute;
    display: flex;
    align-items: center;
    width: 34px;
    height: 34px;
    right: 0;

    .clear-icon {
      width: 20px;
      height: 20px;
    }

    .white-icon {
      filter: invert(100%);
    }
  }

  .sac-search-button {
    position: absolute;
    display: flex;
    align-items: center;
    width: 34px;
    height: 34px;
    left: 16px;

    .search-icon {
      width: 20px;
      height: 20px;
    }

    .white-icon {
      filter: invert(100%);
    }
  }
}
</style>
